var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04167 8L0.916667 1.875C0.708334 1.66666 0.607501 1.42361 0.614167 1.14583C0.620834 0.868053 0.728612 0.624998 0.9375 0.416665C1.14639 0.208331 1.38944 0.104165 1.66667 0.104165C1.94389 0.104165 2.18694 0.208331 2.39583 0.416665L8.8125 6.8125C8.97917 6.97917 9.10417 7.16667 9.1875 7.375C9.27083 7.58333 9.3125 7.79167 9.3125 8C9.3125 8.20833 9.27083 8.41667 9.1875 8.625C9.10417 8.83333 8.97917 9.02083 8.8125 9.1875L2.39583 15.6042C2.1875 15.8125 1.94083 15.9133 1.65583 15.9067C1.37083 15.9 1.12444 15.7922 0.916667 15.5833C0.70889 15.3744 0.604723 15.1314 0.604167 14.8542C0.603612 14.5769 0.707778 14.3339 0.916667 14.125L7.04167 8Z",
    fill: "#9F9F9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleche);
export default __webpack_public_path__ + "static/media/fleche.529820dd0ff647685d4f09949ec246c5.svg";
export { ForwardRef as ReactComponent };